// Footer.js
import React from 'react';
import { Container, Row, Col, ListGroup, Form, FormControl, Button } from 'react-bootstrap';
import { Facebook, Twitter, Instagram, Linkedin } from 'react-bootstrap-icons';
import './Footer.css'; // Adjust the relative path as necessary
import '../App.css'

function Footer() {
    return (
        <footer className="footer">
            <Container>
                <Row className="justify-content-center text-center">
                    <Col xs={12} md={3} className="mb-3 mb-md-0">
                        <h5>Menu</h5>
                        <ListGroup as="ul">
                            <ListGroup.Item as="li">Home</ListGroup.Item>
                            <ListGroup.Item as="li">About</ListGroup.Item>
                            <ListGroup.Item as="li">Portfolio</ListGroup.Item>
                            <ListGroup.Item as="li">Contact</ListGroup.Item>
                            <ListGroup.Item as="li">Get Free Quote</ListGroup.Item>
                        </ListGroup>
                    </Col>
                    <Col xs={12} md={3} className="mb-3 mb-md-0">
                        <h5>Location</h5>
                        <p>Narowal, Punjab Pakistan</p>
                        <p>+923183561921</p>
                        <p>anamsarwar@gmail.com</p>
                    </Col>
                    <Col xs={12} md={3} className="mb-3 mb-md-0">
                        <h5>Social Link</h5>
                        <div className="social-icons">
                            <Facebook size={26} className="social-icon" />
                            <Twitter  size={26} className="social-icon" />
                            <Instagram  size={26} className="social-icon" />
                            <Linkedin  size={25} className="social-icon" />
                        </div>
                    </Col>
                    <Col xs={12} md={3}>
                        <h5>Newsletter</h5>
                        <Form>
                            <Form.Group controlId="newsletterEmail">
                                <FormControl type="email" placeholder="Enter Your Email"  />
                            </Form.Group>
                            <Button variant="success" type="submit" className="btn-subs mt-4">
                                Subscribe
                            </Button>
                        </Form>
                    </Col>
                </Row>
                <Row>
                    <Col xs={12} className="py-3">
                        © 2023 All Rights Reserved By Anam Sarwar
                    </Col>
                </Row>
            </Container>
        </footer>
    );
}

export default Footer;
